import { useNavigate } from "react-router-dom";
import ExternalSources from "./ExternalSources";

/** A real page at /portal/markets/from-source rather than a modal. A picked candidate
 *  hands off to the create-market page as router state — a fetched question still needs
 *  a human to finish it, and the wizard is where that happens. */
export default function FromSourcePage() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto mt-3 w-full max-w-2xl rounded-xl bg-white p-6 shadow-xl dark:bg-navy-800">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-navy-700 dark:text-white">Pull from a source</h2>
        <button type="button" className="text-sm text-gray-500" onClick={() => navigate("/portal/markets")}>
          Close
        </button>
      </div>
      <ExternalSources
        onCandidateConverted={(candidate) => {
          navigate("/portal/markets/new", { state: { seedQuestion: candidate } });
        }}
      />
    </div>
  );
}
